import axios from "axios";

export const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API_BASE, withCredentials: true });

export function apiError(err) {
  const d = err?.response?.data?.detail;
  if (!d) return { message: "Something went wrong. Please try again.", errors: {} };
  if (typeof d === "string") return { message: d, errors: {} };
  if (Array.isArray(d)) return { message: d.map((e) => e?.msg).filter(Boolean).join(" "), errors: {} };
  return { message: d.message || "Please check the form.", errors: d.errors || {} };
}

export const isPlaceholder = (t) => typeof t === "string" && t.startsWith("[PLACEHOLDER");

export const formatDate = (d) => {
  if (!d) return "";
  const dt = new Date(d);
  return isNaN(dt) ? d : dt.toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" });
};
